"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  blExchangeAppointment: {
    // blNoTips: 'Query rule:BlNo(Up to 50 reservations) Multi query rule',
    blNoTips: '"Bill of Lading Number (up to 10 numbers)" For multiple numbers, use a half width English comma to separate them: Bill of Lading Number, Bill of Lading Number.',
    blNoAndCode: 'BlNo/CertifyCode:',
    blNoCNXMNTips: 'Query rule:BlNo/CertifyCode(Up to 10 reservations) Multi query rule: BlNo/CertifyCode,BlNo/CertifyCode...',
    feeInquiry: 'If you have any questions regarding damaged container charges or overdue fees, please send an email to sitcsh_imp@sitc.com for consultation.',
    downloadBill: 'To download the bill, please make a reservation and then download it in the Exchange Order Reservation History.',
    ApplicablePorts: 'Applicable Ports：CNSHK、CNTAO、CNTXG、CNXMN、PH、CNNGB',
    reserved: 'Booked',
    reservationSaved: 'Reservation saved, reviewing attachment format',
    notReserved: 'No appointment',
    reservationFailed: 'Reservation failed.',
    ownerType: 'Owner Type',
    send: 'Send',
    unSend: 'Unsent',
    authorized: 'Authorized',
    unauthorized: 'Unauthorized',
    noPaid: 'No Paid',
    accounted: 'Accounted',
    reviewingAttachment: 'Attachment format is correct, reviewing the amount of the bank slip',
    noDeliveryTime: 'Authorization operation cannot be performed without delivery time maintenance',
    noDeliveryTime1: 'Reservation operation cannot be performed without delivery time maintenance',
    noReservation: 'Authorization operation cannot be performed without reservation',
    customerNotice: 'Dear import customer:',
    confirmReservation: 'Please make sure to confirm whether the bill of lading you want to reserve belongs to imported dangerous goods (included in the "Catalogue of Dangerous Chemicals" 2015 edition, but not restricted by the "International Maritime Dangerous Goods Rules").',
    dangerousGoodsNotice: 'If it is dangerous goods, please declare to our company 48 hours before the ship docks.',
    declarationNotice: 'Please click',
    downloadNotice: '"Customer Notice - Notice on Declaration of Imported Dangerous Goods Container"',
    download: 'Download',
    downloadPrint: 'Download',
    acknowledged: 'I Have Acknowledged',
    manifestUnpaid: 'Manifest is unpaid, please make the payment before making a reservation.',
    confirmOriginalBl: 'Is it an original Bill of Lading? (Confirm for Yes, Cancel for No)',
    portReleasePending: 'The port of departure has not yet notified for telex release or SWB release, booking is not possible.',
    pleaseCheckData: 'Please choice data',
    checkSamePort: 'Please check the same port',
    fileSize: 'File size should not exceed 10MB!',
    fileFormat: 'Uploadable file types are PDF\\\\WORD\\\\JPG, with a size limit of 10M.',
    attachmentFileLength: 'The file name is too long, please control within 40 characters!',
    portMediaCodeFileLength: 'Media code file name is too long, please control within 40 characters!',
    notFileSelected: 'No Files Selected',
    No: 'No.',
    blNoAndContainerNo: 'BlNo:',
    prompt: 'Query rule:BlNo/CntrNo(Up to 10 reservations)',
    promptCondition: 'Multi query rule: BlNo/CntrNo,BlNo/CntrNo...',
    searchResult: 'Search Result',
    foreSpeakInfo: 'Appoint Info',
    foreSpeakCost: 'Appoint cost',
    outVesselCode: 'Out Vessel Code',
    outVoyageNo: 'Out Voyage No',
    outVoyageLeg: 'Out Voyage Leg',
    inVesselCode: 'In Vessel Code',
    inVoyageNo: 'In Voyage No',
    inVoyageLeg: 'In Voyage Leg',
    pod: 'POD',
    blNo: 'Bl No',
    deliverableDate: 'Delivarable Date',
    eta: 'Eta',
    edoSentStatus: 'Edo Sent Status',
    edoSentStatusSh: 'Edo Sent Status',
    accreditSentStatus: 'Accredit Sent Status',
    accreditStatus: 'Accredit Status',
    soaNo: 'Soa No',
    chargeCode: 'Charge Code',
    currency: 'Currency',
    amount: 'Receive Fee',
    containerType: 'Container Type',
    cargoType: 'Cargo Type',
    foreSpeak: 'forespeak',
    vesselCode: 'Vessel Name',
    voyageNo: 'Voyage No',
    voyageLeg: 'Voyage Leg',
    containerNo: 'Container No',
    freeTimeNo: 'F/T',
    pickUpDate: 'Pickup Date',
    promptText: 'Note: For inquiries about OF (ocean freight), please send an email to sitcsh_imp@sitc.com, indicating the ship’s name, voyage number, bill of lading number, and attach a scanned copy of the bill of lading RMB bank account: China Merchants Bank Co., Ltd. Shanghai Beiwaitan Sub-branch RMB bank account number: 121908093010709',
    accreditCustomer: 'Accredit Customer',
    accredit: 'Accredit',
    dem: 'DEM',
    dg: 'DG',
    startDate: 'Start Date',
    endDate: 'End Date',
    FreeUntil: 'Free Until',
    OverDay: 'Over Day',
    ftNo: 'F/T No.',
    confirmAmount: 'Amount',
    tax: 'Tax',
    commission: 'Commission',
    confirmCurrency: 'Currency',
    forespeakCnngb: 'Appoint(CNNGB)',
    forespeakCntao: 'Appoint(CNTAO)',
    forespeakCnxmn: 'Appoint(CNXMN)',
    forespeakCntxg: 'Appoint(CNTXG)',
    forespeakCnshk: 'Appoint(CNSHK)',
    forespeakCommon: 'Appoint',
    pleaseInput: 'Please Enter',
    select: 'Select',
    selectFile: 'Select File',
    voyageNoBlNo: 'Voyage No./ B/L No',
    paymentStatus: 'Payment Status',
    forespeakStatus: 'Appoint Status',
    releaseStatus: 'Release Status',
    doType: 'Do Type',
    electronicBill: 'Electronic Bill',
    paperBill: 'Paper Bill',
    paymentNo: 'Payment No',
    invoiceTitle: 'Invoice Title',
    paymentMethod: 'Payment Method',
    bankSlip: 'Bank Slip',
    portMediaCode: 'QR Code',
    mail: 'Mail',
    receiveEmail: 'Receive Email',
    identifier: 'Identifier',
    identifierXg: 'EDO Receiver Identifier',
    consigneeName: 'Consignee Name',
    consigneeAddress: 'Consignee Address',
    address: 'Address',
    phone: 'Phone',
    accountBank: 'Account Bank',
    invoiceTaxNo: 'Invoice Tax No',
    invoiceBankNo: 'Invoice Bank No',
    powerAttorney: 'Power Attorney',
    blNoNotEmpty: "BlNo Can Not Be Empty!",
    portCodeEmpty: "Port Code Can Not Be Empty!",
    invoiceTitleNotNull: "The Invoice Cannot Be Empty",
    paymentMethodNotNull: "The Payment Method Can Not Be Empty",
    emailNotNull: "The Email Can Not Be Empty",
    invalidEmail: "Email Format Error",
    bankSlipNotNull: "Please Upload The Slip!",
    portMediaCodeNotNull: "Please Upload QR Code!",
    powerAttorneyNotNull: "Please Upload The Billing Order!",
    invalidPhone: "Phone Format Error",
    phoneNotNull: "The Phone Can Not Be Empty",
    paymentNoNotNull: "The Payment Can Not Be Empty",
    invoiceTaxNoNotNull: "The Invoice Tax No Can Not Be Empty",
    invoiceBankNoNotNull: "The Invoice Bank No Can Not Be Empty",
    accountBankNotNull: "The Account Bank Can Not Be Empty",
    addressNotNull: "The Address Can Not Be Empty",
    inputNum: "Input Number",
    reservationSuccessful: 'Reservation successful!',
    reservationFailure: 'Reservation failure!',
    cancelReservationSuccess: 'Cancel Reservation Success!',
    cancelReservationFail: 'Cancel Reservation Fail!',
    lockNotLook: 'Locked Bills of lading cannot be booked!',
    bookedBl: 'The following BL No. has already been appointed and cannot be repeated! \n',
    noDeliverableDate: 'There is no maintenance order change time, can not make an appointment',
    edosentstatusNotEdit: 'EDO has been sent. The reservation information cannot be modified',
    contactCompany: 'Please contact shipping company to release B/L first!',
    payOnSite: 'Please pay the exchange fee on site!',
    bankSlipUploadInstructions: "Bank Slip Upload Instructions:",
    uploadCorrectFile: "1) 如果预约时已上传正确水单和介质码，则换单资料只需递送背书提单。",
    noNeedForSlip: "2) 请上传正确水单和介质码文件，否则无法成功预约！",
    increaseEfficiency: "3) 为提高换单效率，银行水单上传格式将限制为PDF/JPG/PNG/BMP/TIFF，除上述文件格式以外内容将限制上传。一次预约多次付款需上传多份文件的客户，烦请合成一份PDF文件，谢谢!",
    invoiceInfo: "4) 如果是第一次申请开票或公司信息更新的需要填写发票相关信息!",
    // uploadCorrectFile: "1) Please upload the correct payment slip, otherwise the reservation cannot be successful!",
    // noNeedForSlip: "2) If the correct payment slip has been uploaded during the reservation, there is no need to bring the reservation slip and payment slip when exchanging documents.",
    // increaseEfficiency: "3) To improve document exchange efficiency, the bank payment slip upload format is limited to PDF/JPG/PNG/BMP/TIFF. Content outside the aforementioned file formats will be restricted from uploading. If you need to upload multiple files for multiple payments in one reservation, please combine them into one PDF file. Thank you!",
    // invoiceInfo: "4) If this is your first time applying for an invoice or if company information has been updated, please fill in the relevant invoice information!",

    blExchangeRequirement: '***To exchange the original bill of lading for the delivery order, a consignee’s exchange authorization letter must be submitted***',
    blExchangeNote: 'Note: Filling in authorized customer information will not affect the document exchange reservation, but failing to fill it in promptly may affect the acceptance of delivery. Please maintain the authorized customer information in time.',
    blExchangeStep1: '1) If you choose an electronic delivery order, you must maintain the authorized customer code signed with the Shanghai Port Acceptance Center before delivery. The code can be found at',
    blExchangeStep1Part2: '.',
    blExchangeStep2: '2) When choosing an electronic delivery order, a paper delivery order will no longer be provided during document exchange.',
    blExchangeStep3: '3) Please upload the correct remittance slip, otherwise the reservation cannot be successfully completed.',
    blExchangeStep4: '4) To improve the efficiency of document exchange, the format of the uploaded remittance slip will be restricted to PDF/JPG/PNG/BMP/TIFF. Content other than the above formats will be restricted from uploading. For customers who need to upload multiple documents for multiple payments in one reservation, please merge them into one PDF file. Thank you!',
    blExchangeStep5: '5) The amount on the remittance slip must match the amount of the reserved document, otherwise the system will not be able to issue an invoice and will automatically cancel the reservation.',
    contactInfo: 'Import document exchange: 51166938 Mr. Yuan, Import operations: 51188044, 51166906/6928/6934/6954/6956/6957/6958',
    authorizationNote: "Note: Filling in the authorized customer information does not affect the document <br> exchange reservation, but failing to fill it out in a timely manner may impact the <br> acceptance of delivery. Please ensure that the authorized customer information is <br> updated promptly.",
    alreadyReserved: '{blNo} The bill of lading that has been reserved cannot be batch reserved',
    unpaid: '{blNo} Unpaid bills of lading cannot be booked in bulk',
    inconsistentNature: '{blNo} The bill of lading number of the batch reservation is inconsistent',
    lockedBill: '{blNo} Locked bills of lading cannot be reserved for appointment',
    paymentAmount: 'Pay Amount',
    invoiceNumber: 'Invoice Number',
    demurrageReceipt: 'Demurrage Receipt',
    preTaxReceipt: 'Pre Tax Receipt',
    taxFlag: 'Tax Flag',
    documentType: 'Document Type',
    containerGuarantee: 'Container Guarantee',
    authorizationLetter: 'Authorization Letter',
    insuranceCertificate: 'Insurance Certificate',
    idCardScan: 'IdCard Scan',
    billOfLadingCopy: 'Bill Of Lading Copy',
    deliveryOrder: 'Delivery Order',
    obl: 'OBL',
    bankGuaranty: 'Bank Guaranty',
    oblWithBankStamp: 'OBL With Bank Stamp',
    paymentAccount: 'Payment Account',
    paymentBank: 'Payment Bank'
  }
};